export default {
  "t-physical-examination": "Examen Physique",
  "t-physical-examination-logs": "Rapport de Contrôle d'Équipement",
  "t-terminal-data-upload-configuration": "Configuration du Téléchargement de Données du Terminal",
  "t-terminal-strategy-parameters": "Paramètres de Stratégie du Terminal",
  "t-strategy-execution-report": "Rapport d'Exécution de Stratégie",
  "t-terminal-data-analysis": "Analyse des Données du Terminal",
  "t-configuration-parameters": "Paramètres de Configuration",
  "t-data-alert-config": "Configuration des Données et Alertes",
  "t-data-upload-alert-event-config": "Configuration du Téléchargement de Données et des Événements d'Alerte",
  "t-history": "Historique",
  "t-health-check-date": "Date de Contrôle de Santé",
  "t-health-score": "Score de Santé",
  "t-check-items": "Éléments Vérifiés",
  "t-detection-status": "État de Vérification du Matériel",
  "t-device-basic-info": "Informations de Base de l'Appareil",
  "t-healthy": "Sain",
  "t-optimal": "Normal",
  "t-unhealthy": "Malsain",
  "t-skip": "Ignorer",
  "t-printer": "Imprimante",
  "t-voltage": "Tension",
  "t-temperature": "Température",
  "t-charging-status": "Statut de Charge",
  "t-print-distance": "Distance d'Impression",
  "t-print-head-size": "Taille de Tête d'Impression",
  "t-bootloader-version": "Version du Bootloader",
  "t-internal-software-version": "Version du Logiciel Interne",
  "t-uptime": "Temps de Fonctionnement",
  "t-detection-content": "{total} éléments testés au total, {pass} éléments réussis, {skip} éléments ignorés",
  "t-not-charging": "Ne se charge pas",
  "t-charging": "En charge",
  "t-closed": "Fermé",
  "t-opened": "Ouvert",
  "t-mobile-data": "Données Mobiles",
  "t-wifi": "WIFI",
  "t-unknown": "Inconnu",
  "t-medical-inspection": "Inspection Médicale",
  "t-health-status": "État de Santé",
  "t-manual": "Manuel",
  "t-automatic": "Automatique",
  "t-manual-physical-examination-type": "Manuel",
  "t-automatic-physical-examination-type": "Automatique",
  "t-device-data-acquisition": "Acquisition de Données du Dispositif",
  "t-device-data-stop-collection": "Arrêter l'Acquisition de Données du Dispositif",
  "t-device-health-check": "Contrôle de Santé du Dispositif",
  "t-auto-health-check": "Contrôle Automatique de Santé",
  "t-tha-logs": "Journaux de Contrôle de Santé THA",
  "t-battery-brand": "Marque",
  "t-charging-duration": "Durée de Charge",
  "t-charging-current": "Courant de Charge",
  "t-charge-cycles": "Cycles de Charge",
  "t-charge-cycle-count": "Nombre de Cycles de Charge",
  "t-low-temperature-warning-count": "Nombre d'Avertissements de Température Basse",
  "t-high-temperature-warning-count": "Nombre d'Avertissements de Température Élevée",
  "t-data-upload": "Liste de Téléchargement de Données",
  "t-alert-event": "Événement d'Alerte",
  "t-device-config": "Configuration de Dispositif THA",
  "t-config-sync-log": "Journal de Synchronisation de Configuration",
  "t-event-trigger-time": "Heure de Déclenchement de l'Événement",
  "t-event-upload-time": "Heure de Téléchargement de l'Événement",
  "t-battery-overheating": "Alerte de Température Élevée de Batterie",
  "t-battery-undervoltage": "Alerte de Température Basse de Batterie",
  "t-cpu-overheating": "Arrêt pour Température Élevée de Batterie",
  "t-event-battery-high-temperature": "Alerte de température élevée de la batterie",
  "t-event-battery-low-temperature": "Alerte de température basse de la batterie",
  "t-event-cpu-high-temperature": "Température élevée du CPU",
  "t-event-battery-high-temperature-shutdown": "Arrêt pour température élevée de la batterie",
  "t-event-battery-low-temperature-shutdown": "Arrêt pour température basse de la batterie",
  "t-event-type": "Type d'Événement",
  "t-total-records": "Enregistrements Totaux",
  "t-peripheral": "Périphérique",
  "t-module": "Module",
  "t-sampling-period": "Période d'Échantillonnage",
  "t-sampling-period-1-minute": "1 minute",
  "t-sampling-period-3-minutes": "3 minutes",
  "t-sampling-period-5-minutes": "5 minutes",
  "t-sampling-period-10-minutes": "10 minutes",
  "t-sampling-period-30-minutes": "30 minutes",
  "t-sampling-period-60-minutes": "60 minutes",
  "t-upload-interval": "Intervalle de Téléchargement",
  "t-upload-interval-less-than-sampling-period": "L'intervalle de téléchargement ne peut pas être inférieur à la période d'échantillonnage",
  "t-sample-count": "Nombre d'Échantillons",
  "t-valid-sample-count": "Nombre d'Échantillons Valides",
  "t-upload-timestamp": "Horodatage de Téléchargement",
  "t-sample-timestamp": "Horodatage d'Échantillon",
  "t-config-sync-logs": "Journaux de Synchronisation de Configuration",
  "t-data-point": "Point de Données",
  "t-policy-updated": "Politique a Été Mise à Jour",
  "t-policy-consistent": "Politique Est Cohérente",

// 应用信息
  "t-app-name": "Nom de l'Application",
  "t-package-name": "Nom du Paquet",
  "t-is-system": "Est-ce une App Système?",
  "t-app-version": "Version de l'Application",
  "t-authorisations": "Autorisations",
  "t-installed-at": "Installé le",
  "t-app-size": "Taille",
// 网络流量统计
  "t-uplink-traffic": "Trafic de Liaison Montante",
  "t-downlink-traffic": "Trafic de Liaison Descendante",
  "t-traffic-total": "Trafic Total",
  "t-monitor-more": "plus",
// 网络连接状态
  "t-router-name": "Nom du Routeur",
// 外设使用统计
  "t-swipe-card-count": "Nombre de Cartes Balayées",
  "t-insert-card-count": "Nombre de Cartes Insérées",
  "t-tap-card-count": "Nombre de Cartes Tapotées",
  "t-card-fail-count": "Nombre d'Échecs de Carte",
  "t-print-mileage": "Distance d'Impression",
  "t-print-speed": "Vitesse d'Impression",
  "t-print-grayscale": "Échelle de Gris d'Impression",

  "t-open-tha-model-waiting": "La demande THA a été initiée, veuillez patienter ..",
  "t-manually-initiated-health-check-failed": "Échec du lancement manuel du contrôle de santé",
  "t-health-check-initialization-failed": "Échec de l'initialisation du contrôle de santé",
  "t-manually-initiated-health-check-success": "Le contrôle de santé a été lancé avec succès, veuillez consulter le rapport de contrôle de santé",
  "t-monitor-abnormal": "Abnormal",
  "t-monitor-start-date": "Start Date",
  "t-monitor-end-date": "End Date",
  "t-monitor-battery-status": "Battery Status",
  "t-monitor-current-capacity": "Niveau de batterie",
  "t-monitor-key-focus": "Key Focus",
  "t-monitor-battery-trend": "Battery Trend",
  "t-monitor-temperature-battery-threshold": "Temperature Threshold / Battery Threshold",
  "t-monitor-system-resource-trend": "System Resource Trend",
  "t-monitor-storage-high": "High Storage Usage",
  "t-monitor-network-traffic-trend": "Network & Traffic Trend",
  "t-monitor-link-stable": "Stable Link",
  "t-monitor-data-summary": "Data Summary",
  "t-monitor-metric": "Metric",
  "t-monitor-current-value": "Current",
  "t-monitor-minimum-value": "Minimum",
  "t-monitor-maximum-value": "Maximum",
  "t-monitor-average-value": "Average",
  "t-threshold": "Threshold",
  "t-monitor-unit-times": "times",
  "t-monitor-unit-meter": "m",
  "t-monitor-no-sampling-time": "No sampling time",
  "t-monitor-device-info": "Device Info",
  "t-monitor-software-version": "Software Version",
  "t-monitor-sma-version": "SMA Version",
  "t-monitor-pos-service": "POS Service",
  "t-monitor-network-connection": "Network Connection",
  "t-monitor-ip-address": "IP Address",
  "t-monitor-mac-address": "MAC Address",
  "t-monitor-battery-info": "Battery Info",
  "t-monitor-battery-brand": "Battery Brand",
  "t-monitor-collection-summary": "Collection Summary",
  "t-monitor-valid-rate": "Valid Rate",
  "t-monitor-battery-level": "Battery",
  "t-monitor-current": "Current",
  "t-monitor-over-threshold": "Over Threshold",
  "t-monitor-below-threshold": "Below Threshold",
  "t-monitor-idle": "Idle",
  "t-monitor-charge-cycle-stats": "Charge Cycle Statistics",
  "t-monitor-high": "High",
  "t-monitor-charge-count": "Charge Count",
  "t-monitor-cumulative": "Cumulative",
  "t-monitor-current-cycle": "Current Cycle",
  "t-monitor-high-temperature-warning": "High Temp Warning",
  "t-monitor-severe": "Severe",
  "t-monitor-controllable": "Controllable",
  "t-monitor-low-temperature-warning": "Low Temp Warning",
  "t-monitor-system-resource": "System Resource",
  "t-monitor-network-signal": "Network Signal",
  "t-monitor-weak": "Weak",
  "t-monitor-good": "Good",
  "t-monitor-stable": "Stable",
  "t-monitor-application-traffic": "Application Traffic",
  "t-monitor-current-sample": "Current Sample",
  "t-monitor-peripheral-stats": "Peripheral Stats",
  "t-monitor-need-attention": "Needs Attention",
  "t-monitor-usage": "Usage",
  "t-monitor-ethernet": "Ethernet",
  "t-monitor-link-normal": "Link Normal",
  "t-monitor-fetch-failed": "Failed to fetch monitor data",
  "t-version-change-timeline": "Chronologie des changements de version logicielle",
  "t-version-change-count": "{count} changements de version",
  "t-version-timeline-empty": "Aucun enregistrement de changement de version",
  "t-version-timeline-multiple-events": "Événements multiples",
  "t-version-timeline-event": "Événement",
  "t-version-timeline-init": "Initialisation",
  "t-version-timeline-update": "Mise à jour de version",
  "t-version-timeline-upgrade": "Mise à niveau",
  "t-version-timeline-rollback": "Retour arrière",
  "t-version-timeline-exception": "Exception",
  "t-version-timeline-current": "Actuel",
  "t-data-upload-data": "Aperçu des Données THA",
  "t-tha-data-overview": "Aperçu des Données THA",
  "t-manual-physical-examination-and-automatic-physical-examination": "Lors d'un examen physique manuel, le dispositif doit installer POS Manager, cette application est utilisée pour détecter l'écran, le tactile, la caméra, le haut-parleur, les boutons, la reconnaissance digitale, le microphone, le lecteur de cartes magnétiques, le lecteur de cartes à puce, le lecteur de cartes sans contact, l'imprimante, l'indicateur d'état, le buzzer et le module de stockage sécurisé des paiements. Elle inclut également les éléments d'inspection physique automatique : numéro de série du dispositif, heure de l'inspection, état Bluetooth, charge actuelle du CPU, utilisation actuelle de la RAM, utilisation actuelle de la mémoire de stockage, temps de fonctionnement, localisation, état de charge, température de la batterie, tension de la batterie, capacité de la batterie, type de communication, type de signal, adresse du routeur, vitesse de transmission, adresse MAC WiFi, intensité du signal, interrupteur de réseau et distance d'impression",
  "t-manual-physical-examination-and-automatic-physical-examination-auto": "Lors d'une inspection physique automatique, le dispositif n'a pas besoin d'installer POS Manager, cette application est utilisée pour détecter le numéro de série du dispositif, l'heure de l'inspection, l'état Bluetooth, la charge actuelle du CPU, l'utilisation actuelle de la RAM, l'utilisation actuelle de la mémoire de stockage, le temps de fonctionnement, la localisation, l'état de charge, la température de la batterie, la tension de la batterie, la capacité de la batterie, le type de communication, le type de signal, l'adresse du routeur, la vitesse de transmission, l'adresse MAC WiFi, l'intensité du signal, l'interrupteur de réseau et la distance d'impression",
  "t-power-level": "Niveau de Puissance",
}
